/**
 * Hook to access the current sync status from React components.
 */

import { useState, useEffect } from 'react';
import { onSyncStatus, type SyncStatus } from '../lib/sync-manager';

/** Returns the current sync status and optional error message */
export function useSyncStatus(): { status: SyncStatus; error?: string } {
  const [status, setStatus] = useState<SyncStatus>('idle');
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    return onSyncStatus((s, err) => {
      setStatus(s);
      setError(err);
    });
  }, []);

  return { status, error };
}
